export default () => ({
  devicesArray: [],
  devicesCounter: 10,
  loadingState: true
});